export default __webpack_public_path__ + "static/media/relatorio-icon.ca57e706.svg";